
import { useEffect } from 'react'
import Select from 'react-select'
import { WaterSupplyWorkNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WaterSupplyWorkNameDataDDL = (props) => {
    const { WSWorkName, setWSWorkName, WSWorkType, PopUpField, IsPost, WardName, DashProjectTypeId = false, Flag, rowData } = props

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            DashProjectTypeId: DashProjectTypeId,
            M_Distri_WorkTypeID: WSWorkType.ID,
            RoleID: RoleID
        }
        dispatch(WaterSupplyWorkNameDDLAPI({ data }))
    }, [IsPost, WSWorkType.ID, DashProjectTypeId, RoleID])

    const { WaterSupplyWorkNameData } = useSelector(state => state.WaterSupplyWorkNameDDLData)

    useEffect(() => {
        handleWorkTypeDDL()
    }, [WaterSupplyWorkNameData])

    // const handleWorkTypeDDL = () => {
    //     // console.log(DeptDDLDataa)
    //     if (WaterSupplyWorkNameData && WaterSupplyWorkNameData.table && WaterSupplyWorkNameData.table.length > 0) {
    //         // if (DashProjectTypeId == 6) {
    //         let list = WaterSupplyWorkNameData.table.map((item, index) => ({
    //             value: item.m_Distri_WorkNameID,
    //             label: item.workname,
    //         }))
    //         setWSWorkName({
    //             DDL: list,
    //             ID: 0,
    //             Label: "Select...",
    //         })
    //     } else {
    //         let list = WaterSupplyWorkNameData.table.map((item, index) => ({
    //             value: item.m_wS_PipeLineID,
    //             label: item.pipelineDetails,
    //         }))
    //         setWSWorkName({
    //             DDL: list,
    //             ID: 0,
    //             Label: "Select...",
    //         })
    //     }else {
    //         setWSWorkName({
    //             DDL: [],
    //             ID: 0,
    //             Label: "Select...",
    //         })
    //     }
    // }

    const handleWorkTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (WaterSupplyWorkNameData && WaterSupplyWorkNameData.table && WaterSupplyWorkNameData.table.length > 0) {
            if (DashProjectTypeId == 6 && RoleID != '16') {
                let list = WaterSupplyWorkNameData.table.map((item, index) => ({
                    value: item.m_Distri_WorkNameID,
                    label: item.workname,
                }))
                setWSWorkName({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_Distri_WorkNameID : 0,
                    Label: Flag === 'Update' ? rowData.workname : "Select...",
                })
            } 
              else if (DashProjectTypeId == 9) { // TTP
                let list = WaterSupplyWorkNameData.table.map((item, index) => ({
                    value: item.m_ttP_WorkNameID,
                    label: item.workname,
                }))
                setWSWorkName({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_ttP_WorkNameID : 0,
                    Label: Flag === 'Update' ? rowData.workname : "Select...",
                })
            }
            else {
                let list = WaterSupplyWorkNameData.table.map((item, index) => ({
                    value: item.m_wS_WorkNameID,
                    label: item.workname,
                }))
                setWSWorkName({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_wS_WorkNameID : 0,
                    Label: Flag === 'Update' ? rowData.workname : "Select...",
                })
            }


        }
        else {
            setWSWorkName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }



    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Work Name </b></label>
            <Select
                isSearchable
                isClearable
                maxMenuHeight={150}
                value={{ value: WSWorkName.ID, label: WSWorkName.Label }}
                onChange={(e) => {
                    e ?
                        setWSWorkName({ ...WSWorkName, ID: e.value, Label: e.label })
                        :
                        setWSWorkName({ ...WSWorkName, ID: 0, Label: "Select..." })

                }}
                options={WSWorkName.DDL}
            />
        </div>
    )
}